<template>
  <div>
    <header>
      <div class="trademarkClass">
        <div class="head">
          <div id="logo">
            <img src="@/assets/logo.png" />
          </div>
          <div id="wl">
            <p>
              <img src="@/assets/wl.png" />
            </p>
            <div>
              <div id="bar" />
              <p>专业提供蔬菜配送、食材配送、食堂承包、食堂托管</p>
              <div id="bar" />
            </div>
          </div>
        </div>
        <div class="tail">
          <img src="@/assets/公众号.jpg" />
          <div id="tel">
            <p>
              <img src="@/assets/phone@2x.png" />
            </p>
            <!-- <br /> -->
            <br />
          </div>
          <div id="number">
            <h1>热线电话</h1>
            <!-- <a href="tel:400-777-0090">400-777-0090</a> -->
            <a href="tel:13648688458">13648688458</a>
          </div>
        </div>
      </div>
    </header>
    <nav>
      <div>
        <a
          :style="style(route.redirect?route.redirect:route.path)"
          v-for="route in permission_routers[0].children"
          :key="route.path"
          @click="resolvePath(route.path)"
        >{{route.meta.title}}</a>
      </div>
    </nav>
    <router-view :key="key" />
    <footer>
      <div class="Box">
        <div id="form">
          <div v-for="item in from" :key="item.key">
            <span style="wdith:100px">{{item.key}}：</span>
            <a :href="item.url" target="_blank">{{item.value}}</a>
          </div>
          <div style="color:#fff;margin-top: 5px;">
            <a href="https://www.12377.cn/" target="_blank"> <img style="border:0"  src="@/assets/footer1.jpg" /></a>
            <a href="https://beian.miit.gov.cn" target="_blank" style="marginLeft:10px"> <img style="border:0"  src="@/assets/footer2.jpg" /></a>
            <a href="https://gdca.miit.gov.cn" target="_blank" style="marginLeft:10px"> <img style="border:0"  src="@/assets/footer3.jpg" /></a>
            <a href="http://gaj.gz.gov.cn" target="_blank" style="marginLeft:10px"> <img style="border:0"  src="@/assets/footer4.jpg" /></a>
          </div>
        </div>
        <div id="code">
          <span>
            <div>
              <img id="one" src="@/assets/公众号.jpg" />
              <img id="two" src="@/assets/图层 3@2x.jpg" />
            </div>
            <p>扫一扫了解更多内容！</p>
          </span>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";
import path from "path";
export default {
  name: "Home",
  data() {
    return {
      basePath: "",
      from: [
        {
          key: "地址",
          value: "深圳市坪山区碧岭街道汤坑社区马峦家德工业园一区2栋"
        },
        { key: "联系人", value: "陈金东" },
        { key: "手 机", value: "13648688458", url: "tel:13648688458" },
        { key: "网 址", value: "www.szwlgyl.com" },
        { key: "备案号", value: "粤ICP备20019611号" ,url:'https://beian.miit.gov.cn'},
      ]
    };
  },
  computed: {
    ...mapGetters(["permission_routers"]),
    key() {
      return this.$route.fullPath;
    }
  },
  methods: {
    resolvePath(routePath) {
      this.$router.push(path.resolve(this.basePath, routePath));
    },
    style(routePath) {
      if (this.$route.path == "/" + routePath) return "background: #f82616";
    }
  },
  created() {
    const roles = "admin";
    store.dispatch("GenerateRoutes", { roles }).then(() => {
      router.addRoutes(store.getters.addRouters);
    });
  }
};
</script>
<style scoped lang="scss">
header {
  height: 6.5rem;
  justify-content: center;
  display: flex;
  .trademarkClass {
    width: 100%;
    max-width: 1200px;
    align-items: center;
    justify-content: space-between;
    display: flex;
    .head {
      display: flex;
      #logo {
        img {
          height: 4.56rem;
        }
      }
      #wl {
        display: flex;
        justify-content: center;
        flex-direction: column;
        div {
          #bar {
            width: 1.875rem;
            height: 0.125rem;
            background: rgba(179, 179, 179, 1);
          }
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          height: 1.75rem;
        }
        p {
          font-size: 0.875rem;
        }
      }
    }
    .tail {
      display: flex;
      align-items: center;
      img {
        height: 6rem;
      }
      #tel {
        display: flex;
        flex-direction: column;
        p {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.625rem;
          height: 1.625rem;
          background: rgba(50, 114, 190, 1);
          border-radius: 50%;
        }
        img {
          height: 1rem;
        }
      }
      #number {
        h1 {
          font-size: 0.875rem;
          color: rgba(153, 153, 153, 1);
          margin: 0;
        }
        a {
          display: flex;
          align-items: center;
          font-size: 1.125rem;
          font-weight: bold;
          font-style: italic;
          color: #3272be;
        }
      }
    }
  }
  div {
    p {
      margin: 0 0.5rem;
    }
  }
}
nav {
  min-width: auto;
  background: #5ead4a;
  min-height: 3.75rem;
  display: flex;
  justify-content: center;
  div {
    width: 100%;
    max-width: 1200px;
    display: flex;
    a {
      line-height: 0;
      width: 6rem;
      min-height: 3.75rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-style: italic;
      color: rgba(255, 255, 255, 1);
      margin-right: 0.725rem;
      margin-left: 0.725rem;
      border-radius: 8%;
    }
    a:hover {
      background: #f82616;
      border-radius: 8%;
    }
  }
}
footer {
  background: #333333;
  height: 18.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .Box {
    width: 1200px;
  }
  div {
    width: 50%;
    display: flex;
  }
  #code {
    justify-content: flex-end;
    border-left-style: solid;
    border-left-color: rgba(66, 66, 66, 1);
    border-left-width: 2px;
    span {
      display: flex;
      justify-content: center;
      flex-direction: column;
      div {
        #one {
          // width: 24rem;
          height: 8.5rem;
          border-radius: 0.5rem;
          margin-right: 1rem;
        }
        #two {
          // width: 9.8125rem;
          height:8.5rem;
        }
      }
      p {
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 1);
        line-height: 1.5rem;
      }
    }
  }
  #form {
    flex-direction: column;
    display: flex;
    div {
      width: 100%;
      span {
        width: 6rem;
        text-align-last: justify;
        text-align: justify;
        display: block;
        color: rgba(255, 255, 255, 1);
        line-height: 1.5rem;
        font-weight: bold;
      }
      a {
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 1.5rem;
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue